import { Check } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Landing V2 — Pricing (quiet). Flat typography, no card, no section borders.
 * A small priced paragraph at the bottom of the page.
 */
export function PricingQuiet() {
  const { t, tRaw } = useLanguage();

  const rawBullets = tRaw("landing.v2Pricing.bullets");
  const bullets: string[] = Array.isArray(rawBullets) ? (rawBullets as string[]) : [];

  return (
    <section className="relative px-6">
      <div className="max-w-md mx-auto space-y-3 text-center">
        <p className="text-xs text-muted-foreground/70">
          {t("landing.v2Pricing.eyebrow")}
        </p>

        {/* Price */}
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-lg text-muted-foreground font-medium">
            {t("landing.v2Pricing.currency")}
          </span>
          <span className="text-4xl font-semibold text-foreground tracking-tight tabular-nums">
            {t("landing.v2Pricing.price")}
          </span>
          <span className="text-sm text-muted-foreground ml-1">
            {t("landing.v2Pricing.period")}
          </span>
        </div>

        <p className="text-sm text-muted-foreground leading-snug">
          {t("landing.v2Pricing.tagline")}
        </p>

        {/* Bullets */}
        <ul className="space-y-1.5 pt-0 inline-block text-left mx-auto">
          {bullets.map((bullet, i) => (
            <li key={i} className="flex items-start gap-3">
              <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
              <span className="text-sm text-muted-foreground leading-relaxed">
                {bullet}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
